import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import SEO from '../components/SEO';

export default function NotFoundPage() {
  return (
    <div className="bg-[#EBE4DE] text-[#2E2C28] min-h-screen">
      <SEO title="Page not found | Founder Growth Collective" description="The page you were looking for could not be found." path="/404" robots="noindex, follow" />
      <Navbar />
      <main className="pt-40 pb-24 min-h-[60vh]">
        <div className="max-w-[900px] mx-auto px-6 lg:px-12">
          <p className="sec-num text-sm tracking-[0.3em] uppercase">/ 404</p>
          <h1 className="mt-6 font-serif text-[48px] lg:text-[72px] leading-[1.02] font-light">This page cannot be found.</h1>
          <p className="mt-6 text-lg text-[#4a463f] font-light max-w-lg">The link may be outdated. Here are some useful places to go instead:</p>
          <ul className="mt-8 space-y-2 text-base text-[#2E2C28]">
            <li><Link to="/" className="underline decoration-[#B5876C]/50 underline-offset-4 hover:text-[#B5876C]">Home</Link></li>
            <li><Link to="/services" className="underline decoration-[#B5876C]/50 underline-offset-4 hover:text-[#B5876C]">Services</Link></li>
            <li><Link to="/founder-led-sales" className="underline decoration-[#B5876C]/50 underline-offset-4 hover:text-[#B5876C]">Founder-Led Sales</Link></li>
            <li><Link to="/about" className="underline decoration-[#B5876C]/50 underline-offset-4 hover:text-[#B5876C]">About Hannah</Link></li>
            <li><Link to="/contact" className="underline decoration-[#B5876C]/50 underline-offset-4 hover:text-[#B5876C]">Book a Discovery Call</Link></li>
          </ul>
        </div>
      </main>
      <Footer />
    </div>
  );
}
